































































































import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import SearchBar from '@/components/SearchBar.vue';
import UsersList from '@/components/UsersList.vue';
import UserEdit from '@/components/UserEdit.vue';
import { Action, Getter } from 'vuex-class';
import Table from '@/components/Table.vue';
import Dialog from '@/components/Dialog.vue';
import {User} from '@/types';
import UserService from '@/services/user.service';
import GenericButton from '@/components/GenericButton.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import ActionBarButton from '@/components/ActionBarButton.vue';
import moment from 'moment';

@Component({
  components: {
    ActionBarButton,
    ConfirmButton,
    CancelButton,
    GenericButton,
    Dialog,
    Table,
    SearchBar,
    UsersList,
    UserEdit,
  },
})
export default class Users extends Vue {
  private showUserDialog: boolean = false;
  private searchString: string = '';
  @Action private addToastErrorMessage: any;
  @Getter private login: any;
  @Getter private hasPermission: any;

  private showDisposeDialog: boolean = false;

  private users: any;
  private showDisposeAction: boolean = false;
  private showCheckboxes: boolean = true;
  private fixedHeader: boolean = false;
  private selectedUser: User = {} as User;
  private editing: boolean = false;
  private loading: boolean = false;

  private selectedRows: User[] = [];
  private numRows: number = 15;
  private paginationOptions: number[] = [];

  private tableData: any = {
    headers: [
      {
        text: 'First Name',
        value: 'first_name',
        align: 'start',
        filterable: true,
      },
      { text: 'Last Name', value: 'last_name' },
      { text: 'Email', value: 'email', filterable: true },
      { text: 'Roles', value: 'roles' },
      { text: 'MFA Enabled', value: 'mfa_enabled' },
      { text: 'Last Login', value: 'last_login' },
    ],
    total: 0,
    filters: {},
    distinctRows: {},
  };

  private async mounted() {
    await this.populateUsers();
  }

  private async addUser(id: number) {
    this.showUserDialog = true;

    id > 0 ?
        Vue.set(this, 'selectedUser', this.$store.getters.getUserById(id)) :
        Vue.set(this, 'selectedUser', {first_name: '', last_name: '', email: ''});

    this.$emit('showUserDialog', true);
  }
  private async searchUsers(searchText: string) {
    this.$set(this, 'searchString', searchText);
  }

  private checkboxValuesChanged(checkboxValues: any[]) {
    this.selectedRows = checkboxValues;
    this.updateActionMenu();
  }

  private updateActionMenu() {
    this.showDisposeAction = !!this.selectedRows.length;
  }

  private async populateUsers() {
    const { users } = await UserService.getUsersForOrganisation();
    const rows = users.map((row: User, index: number) => {
      return {
        id: row.id,
        index,
        first_name: row.first_name || '(invite pending)',
        last_name: row.last_name,
        email: row.email,
        roles: row.roles.map((role: any) => role.name),
        sortedRoles: row.roles
            .map((role: any) => {
              return { name: role.name, id: role.id };
            })
            .sort((a: any, b: any) => a.id - b.id),
        roleIds: row.roles.map((role: any) => role.id),
        mfa_enabled: row.mfa_enabled ? 'Yes' : 'No',
        last_login: this.formatDate(row.last_login) || 'Never',
      };
    });
    Vue.set(this.tableData, 'rows', rows);
  }

  private getColor(role: any) {
    switch (role.name) {
      case 'Super Admin':
        return 'rgba(1,110,161,0.6)';
      case 'Organisation Admin':
        return '#016EA1';
      case 'User':
        return 'rgba(1,110,161,0.4)';
      default:
        return 'primary';
    }
  }

  private handleRowClicked(row: any) {
    this.selectedUser = this.tableData.rows[row.index];
    this.editing = true;
    this.showUserDialog = true;
  }

  private async disposeUsers() {
    this.loading = true;

    try {
      await Promise.all(this.selectedRows.map((user) => UserService.removeUser(user.id)));

      this.showDisposeAction = false;
      this.showDisposeDialog = false;
      this.selectedRows = [];

      await this.populateUsers();
    } finally {
      this.loading = false;
    }
  }

  private formatDate(date?: Date | null) {
    if (!date) {
      return '';
    }

    return moment(date).format('DD MMM YYYY HH:mm:ss');
  }
}
